// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnAddTab {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* right: 0; */
  z-index: 1;
  /* top: 0; */
  /* transform: none; */
  padding: 0.2rem 0.5rem;
  width: 60px;
  right: -40px !important;
}

/*
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 900px) {
  a {
    font-size: 1.2rem;
  }
  a > i {
    font-size: 1.2rem;
  }
}
.btn.disabled,
.btn:disabled,
button:disabled,
button.disabled {
  cursor: none;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/button/button.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;;;;CAAA;AAKA;EACE;IACE,iBAAA;EACF;EACA;IACE,iBAAA;EACF;AACF;AACA;;;;EAIE,YAAA;AACF","sourcesContent":[".btnAddTab {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: absolute;\r\n  /* right: 0; */\r\n  z-index: 1;\r\n  /* top: 0; */\r\n  /* transform: none; */\r\n  padding: 0.2rem 0.5rem;\r\n  width: 60px;\r\n  right: -40px !important;\r\n}\r\n\r\n/*\r\nMax width before this PARTICULAR table gets nasty\r\nThis query will take effect for any screen smaller than 760px\r\nand also iPads specifically.\r\n*/\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 900px) {\r\n  a {\r\n    font-size: 1.2rem;\r\n  }\r\n  a > i {\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n.btn.disabled,\r\n.btn:disabled,\r\nbutton:disabled,\r\nbutton.disabled {\r\n  cursor: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
